import JdSound from "../../../../jd/module/jd_sound";

//发牌丢牌动画
const {ccclass, property} = cc._decorator;

@ccclass
export class K9DealCardsEffect extends cc.Component {

    private smallRotate:number;
    private smallPos:cc.Vec2;

    init(){
        this.smallPos = this.node.position;
        this.smallRotate = this.node.angle;
    }

    //发牌动画
    dealCardsAction(start:cc.Node,func:Function,smallPos:cc.Vec2,smallRotate:number){
        JdSound.playDealCard();
        this.resumeHands();
        let tempLocaltion = start.convertToWorldSpaceAR(cc.Vec2.ZERO);
        //转换成相对small节点的坐标
        let localPos = this.node.parent.convertToNodeSpaceAR(tempLocaltion);
        let card = this.node;
        if (card) {
            card.position = localPos;
            card.stopAllActions();
            card.opacity = 0;
            let r = smallRotate;
            card.angle = 138;
            let time = 0.3
            let moveTo = cc.moveTo(time,smallPos);
            let rotate = cc.rotateTo(time,r);
            let op = cc.fadeIn(0.1);
            let spwan = cc.spawn(moveTo,rotate,op);
            let sequence = cc.sequence(spwan,cc.callFunc(func));
            card.runAction(sequence);
        }
    }

    //我方发牌动画
    dealMyCardsAction(start:cc.Node,movetoPos:cc.Vec2,smallRotate:number,func?:Function){
            JdSound.playDealCard();
            this.resumeHands();
            let tempLocaltion = start.convertToWorldSpaceAR(cc.Vec2.ZERO);
            //转换成相对small节点的坐标
            let localPos = this.node.parent.convertToNodeSpaceAR(tempLocaltion);
            let card = this.node;
            if (card) {
                card.position = localPos;
                card.scale = 0.3;
                card.stopAllActions();
                card.opacity = 0;
                let r = smallRotate;
                card.angle = 130;

                let time = 0.3
                let scale = cc.scaleTo(time,1);
                let moveTo = cc.moveTo(time,movetoPos);
                let rotate = cc.rotateTo(time,r);
                let op = cc.fadeIn(0.1);
                let spwan = cc.spawn(moveTo,rotate,scale,op);
                let sequence = cc.sequence(spwan,cc.callFunc(func));
                card.runAction(sequence);
            }
        }

    //丢牌动画
    throwCardsAction(start:cc.Node){
        this.resumeHands();
        let tempLocaltion = start.convertToWorldSpaceAR(cc.Vec2.ZERO);
        //转换成相对small节点的坐标
        let localPos = this.node.parent.convertToNodeSpaceAR(tempLocaltion);
        let card = this.node;
        if (card) {
            //let r = this.smallRotate;
            let time = 0.6
            let ease = cc.easeOut(1.3);
            let moveTo = cc.moveTo(time,localPos).easing(ease);
            let rotate = cc.rotateBy(time,210);
            let op = cc.fadeOut(0.55);
            let spwan = cc.spawn(moveTo,rotate,op);
            card.runAction(spwan);
        }
    }

        //丢牌动画
    throwMySelfCardsAction(start:cc.Node){
            this.resumeHands();
            let tempLocaltion = start.convertToWorldSpaceAR(cc.Vec2.ZERO);
            //转换成相对small节点的坐标
            let localPos = this.node.parent.convertToNodeSpaceAR(tempLocaltion);
            let card = this.node;
            if (card) {
                //let r = this.smallRotate;
                let time = 0.6
                let ease = cc.easeOut(1.3);
                let moveTo = cc.moveTo(time,localPos).easing(ease);
                let rotate = cc.rotateBy(time,210);
                let scalTo = cc.scaleTo(time,0.3);
                let op = cc.fadeOut(0.55);
                let spwan = cc.spawn(moveTo,rotate,op,scalTo);
                card.runAction(spwan);
            }
        }

    resumeHands(){
        this.node.stopAllActions();
        this.node.scale = 1;
        this.node.active = true;
        this.node.opacity = 255;
    }

    reset(){
        this.node.stopAllActions();
        this.node.opacity = 0;
        this.node.active = false;
    }
}
